import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import CooperationTaskModel from '../../../model/cooperationTask.model';
import TaskService from '../../../api/task/task.service';

@Component({
  selector: 'app-task',
  templateUrl: './task.component.html',
  styleUrls: ['./task.component.scss']
})
export class TaskComponent implements OnInit {
  @Input() task: CooperationTaskModel;
  @Output() deleted = new EventEmitter<CooperationTaskModel>();

  constructor(private taskService: TaskService) { }

  ngOnInit(): void {
  }

  public deleteTask(task: CooperationTaskModel) {
    this.taskService.delete(task).subscribe(result => {
      if(result) {
        this.deleted.emit(task);
      }
    });
  }

  public checkboxClicked() {
    if(this.task.done) {
      this.taskService.undone(this.task).subscribe(result => {
        if(result) {
          this.task.done = null;
        }
      });
    } else {
      this.taskService.done(this.task).subscribe(result => {
        if(result) {
          this.task.done = new Date();
        }
      });
    }
  }
  public getLogo() {
    if(this.task.cooperation != null && this.task.cooperation.customer != null && this.task.cooperation.customer.logo != null) {
      return this.task.cooperation.customer.logo.filename;
    }
    return null;
  }

}
